import axios from "axios";
import {tokenHeaders} from "../http_common";
let burl = process.env.VUE_APP_API;

export function getAllIdcc(){
    return axios.get(burl + '/api/idcc/all',{
        headers : tokenHeaders
    });
}
